module.exports = __webpack_public_path__ + "img/icon2.d79da154.png";